import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, className = "", y = 40 }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.85, delay, ease: [0.16, 1, 0.3, 1] }}
  >
    {children}
  </motion.div>
);

export const Chapter = ({ number, label }) => (
  <div className="flex items-center gap-4" data-testid={`chapter-${number}`}>
    <span className="font-code text-xs font-semibold tracking-[0.3em] text-amber-400">
      {number}
    </span>
    <span className="h-px w-12 bg-amber-400/60" />
    <span className="font-code text-xs uppercase tracking-[0.35em] text-slate-400">
      {label}
    </span>
  </div>
);
